import { render, staticRenderFns } from "./PeriodComparatorLegend.vue?vue&type=template&id=1906f83a&"
import script from "./PeriodComparatorLegend.vue?vue&type=script&lang=js&"
export * from "./PeriodComparatorLegend.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports